import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";

const EventDetailPage = () => {
  const { id } = useParams(); // Pobieramy ID wydarzenia z URL
  const navigate = useNavigate();
  const [event, setEvent] = useState(null);
  const [availableUsers, setAvailableUsers] = useState([]); // Lista dostępnych użytkowników
  const [selectedUserId, setSelectedUserId] = useState(""); // Wybrany użytkownik
  const [newStatus, setNewStatus] = useState(""); // Stan nowego statusu
  const [error, setError] = useState(null);

  // Pobranie szczegółów wydarzenia i dostępnych użytkowników
  useEffect(() => {
    const fetchEvent = async () => {
      try {
        const response = await api.get(`/Events/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        console.log("Event data:", response.data); // Dodaj debugowanie
        setEvent(response.data);
        setNewStatus(response.data.status);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch event details. Please try again later.");
      }
    };

    const fetchAvailableUsers = async () => {
      try {
        const usersResponse = await api.get(`/Users`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        setAvailableUsers(usersResponse.data); // Ustawienie listy dostępnych użytkowników
      } catch (err) {
        console.error(err);
        setError("Failed to fetch users. Please try again later.");
      }
    };

    fetchEvent();
    fetchAvailableUsers();
  }, [id]);

  // Przypisywanie użytkownika do wydarzenia
  const handleAssignUser = async () => {
    if (!selectedUserId) {
      alert("Please select a user to assign.");
      return;
    }

    try {
      await api.post(`/Users/${selectedUserId}/add-to-event/${id}`, null, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      alert("User assigned successfully!");

      // Pobranie zaktualizowanych danych wydarzenia
      const updatedEvent = await api.get(`/Events/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setEvent(updatedEvent.data); // Aktualizacja stanu wydarzenia
      setSelectedUserId(""); // Reset wyboru użytkownika
    } catch (err) {
      if (err.response && err.response.status === 409) {
        alert("This user is already assigned to the event.");
      } else {
        alert("Failed to assign user. Please try again.");
      }
      console.error(err);
    }
  };

  // Zmiana statusu wydarzenia
  const handleStatusChange = async () => {
    try {
      await api.patch(`/Events/${id}/status`, JSON.stringify(newStatus), {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      alert("Status updated successfully!");
      setEvent({ ...event, status: newStatus }); // Aktualizacja statusu w stanie lokalnym
    } catch (err) {
      console.error(err);
      alert("Failed to update status. Please try again.");
    }
  };

  // Usuwanie wydarzenia
  const handleDelete = async () => {
    if (window.confirm("Are you sure you want to delete this event?")) {
      try {
        await api.delete(`/Events/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        alert("Event deleted successfully!");
        navigate("/events"); // Przekierowanie po usunięciu
      } catch (err) {
        console.error(err);
        alert("Failed to delete event. Please try again.");
      }
    }
  };

  if (error) {
    return <div>{error}</div>;
  }

  if (!event) {
    return <div>Loading event details...</div>;
  }

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">{event.title}</h1>
      <p className="text-gray-700 mb-4">
        <strong>Description:</strong> {event.description}
      </p>
      <p>
        <strong>Location:</strong> {event.location}
      </p>
      <p>
        <strong>Date:</strong> {new Date(event.date).toLocaleString()}
      </p>
      <p>
        <strong>Status:</strong> {event.status}
      </p>
      <p>
        <strong>Users:</strong>
      </p>
      {event.users && event.users.length > 0 ? (
        <ul className="list-disc ml-6">
          {event.users.map((user) => (
            <li key={user.id}>
              {user.name} ({user.email})
            </li>
          ))}
        </ul>
      ) : (
        <p>No users assigned</p>
      )}

      {/* Zmiana statusu */}
      <div className="mt-6">
        <label htmlFor="status" className="block mb-2 text-gray-700">
          Change Status:
        </label>
        <select
          id="status"
          value={newStatus}
          onChange={(e) => setNewStatus(e.target.value)}
          className="border border-gray-300 rounded px-3 py-2"
        >
          <option value="Planned">Planned</option>
          <option value="InProgress">In Progress</option>
          <option value="Completed">Completed</option>
          <option value="Cancelled">Cancelled</option>
        </select>
        <button
          onClick={handleStatusChange}
          className="ml-2 bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600"
        >
          Update Status
        </button>
      </div>

      {/* Przypisywanie użytkownika */}
      <div className="mt-6">
        <h2 className="text-lg font-semibold mb-4">Assign User to Event</h2>

        <label htmlFor="userSelect" className="block mb-2">
          Select a user:
        </label>
        <select
          id="userSelect"
          name="userSelect" // Dodanie name
          value={selectedUserId}
          onChange={(e) => setSelectedUserId(e.target.value)}
          className="border border-gray-300 rounded px-3 py-2 mr-4"
        >
          <option value="">Select a user</option>
          {availableUsers.map((user) => (
            <option key={user.id} value={user.id}>
              {user.name} ({user.email})
            </option>
          ))}
        </select>

        <button
          onClick={handleAssignUser}
          className="bg-green-500 text-white py-2 px-4 rounded hover:bg-green-600"
        >
          Assign User
        </button>
      </div>

      {/* Akcje: Powrót, edycja i usunięcie */}
      <div className="mt-6">
        <button
          onClick={() => navigate("/events")}
          className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 mr-4"
        >
          Back to Events
        </button>
        <button
          onClick={() => navigate(`/events/edit/${id}`)}
          className="bg-yellow-500 text-white py-2 px-4 rounded hover:bg-yellow-600 mr-4"
        >
          Edit Event
        </button>
        <button
          onClick={handleDelete}
          className="bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600"
        >
          Delete Event
        </button>
      </div>
    </div>
  );
};

export default EventDetailPage;
